import {
  QueryClient,
  QueryClientProvider as ReactQueryClientProvider,
} from 'react-query';

export const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
    },
  },
});

export const QueryClientProvider = ({
  children,
  client = defaultQueryClient,
}: {
  children: React.ReactNode;
  client?: QueryClient;
}) => (
  <ReactQueryClientProvider client={client}>
    {children}
  </ReactQueryClientProvider>
);
